export * from "ce/selectors/workspaceSelectors";
import type { DefaultRootState } from "react-redux";

export const getGroupSuggestions = (state: DefaultRootState) => {
  return state.ui.workspaces.groupSuggestions;
};

export const getIsImportingPackage = (state: DefaultRootState) => {
  return state.ui.workspaces.loadingStates.isImportingPackage;
};

export const getIsImportingWorkflow = (state: DefaultRootState) => {
  return state.ui.workspaces.loadingStates.isImportingWorkflow;
};

export const getImportedPackage = (state: DefaultRootState) => {
  return state.ui.workspaces.importedPackage;
};

export const getImportedWorkflow = (state: DefaultRootState) => {
  return state.ui.workspaces.importedWorkflow;
};

export const getCreatePackageModalState = (state: DefaultRootState) => {
  return state.ui.workspaces.createPackageModal;
};
